import { z } from 'zod';

export const CUSTOMER_PAYMENT_CURRENCIES = ['ILS','USD','EUR','GBP'] as const;
export const customerPaymentMerchantSchema = z.object({
  enabled: z.boolean(), environment: z.enum(['sandbox','production']),
  apiKey: z.string().trim().max(500).optional(), secretKey: z.string().trim().max(500).optional(),
  pageUid: z.string().trim().min(1).max(100), receiptProvider: z.enum(['none','payplus']).default('none'),
});
export const customerPaymentCreateSchema = z.object({
  idempotencyKey: z.string().uuid(), description: z.string().trim().min(1).max(200),
  amount: z.number().positive().max(1_000_000).refine(value => Math.abs(value * 100 - Math.round(value * 100)) < 0.000001, 'customerPayments.errors.amount'),
  currency: z.enum(CUSTOMER_PAYMENT_CURRENCIES).default('ILS'),
  customerName: z.string().trim().min(1).max(120), customerEmail: z.string().trim().email().max(160),
  customerPhone: z.string().trim().max(40).default(''), customerCity: z.string().trim().max(100).default(''),
  installments: z.number().int().min(1).max(36).default(1),
  locale: z.enum(['he','en']).default('he'), approvalCode: z.string().regex(/^\d{4}$/).optional(),
  expiresInDays: z.number().int().min(1).max(30).default(7),
});
export const customerPaymentCodeSchema = z.object({code:z.string().regex(/^\d{4}$/,'customerPayments.errors.code'),installments:z.number().int().min(1).max(36).optional()});
export const customerPaymentShareSchema = z.object({
  channel:z.enum(['email','whatsapp','copy']), kind:z.enum(['request','confirmation','receipt']).default('request'),
  recipient:z.string().trim().max(160).optional(),
});
export type CustomerPaymentCreate = z.infer<typeof customerPaymentCreateSchema>;
export type CustomerPaymentMerchantInput = z.infer<typeof customerPaymentMerchantSchema>;
export interface CustomerPaymentMerchant {
  enabled:boolean; environment:'sandbox'|'production'; pageUid:string; receiptProvider:'none'|'payplus';
  hasApiKey:boolean; hasSecretKey:boolean;
}
export type CustomerPaymentStatus = 'pending'|'paid'|'declined'|'cancelled';
export interface CustomerPaymentReceipt {
  /** documentId is a technical artifact identity; it is never a fiscal number. */
  provider:string; documentId:string; number:string|null; type:string; url:string; verifiedAt:string;
}
export interface CustomerPayment {
  id:string; description:string; businessName:string; amount:number; currency:typeof CUSTOMER_PAYMENT_CURRENCIES[number];
  customerName:string; customerCity:string; installments:number; maxInstallments:number;selectedInstallments:number|null; locale:'he'|'en';
  status:CustomerPaymentStatus; checkoutStatus:'new'|'creating'|'ready'|'uncertain';
  receiptStatus:'pending'|'available'; receipt:CustomerPaymentReceipt|null; createdAt:string; expiresAt:string; paidAt:string|null;
  publicUrl:string; approvalCode?:string; customerEmail?:string; customerPhone?:string;
}
export interface CustomerPaymentEvent {id:string;status:string;transactionId:string|null;verifiedAt:string;}
export interface CustomerPaymentDelivery {id:string;channel:string;kind:string;recipient:string|null;status:string;createdAt:string;errorCode:string|null;}
export interface CustomerPaymentDetail {payment:CustomerPayment;events:CustomerPaymentEvent[];deliveries:CustomerPaymentDelivery[];}
